export default __webpack_public_path__ + "static/media/login_instead.7627ae69.svg";